import { ColorNeutralWhite, ColorNordicGrey2 } from 'autogen/design-tokens/tokens';
import SmartSideDrawerView from 'components/generic/smartview/smartviewSideDrawer/components/SmartSideDrawerView';
import { ISmartSideDrawerView } from 'components/generic/smartview/smartviewSideDrawer/shared/types';
import { MenuHeaderProps } from 'components/sideMenu/components/Menu/components/MenuHeader';
import styled from 'styled-components';
import { customScrollbar } from 'modules/helpers/mixins';
import LoadingContainer from 'components/checkout/components/BasketOverview/components/LoadingContainer';
import { useIsFetching } from '@tanstack/react-query';
import Menu from 'components/generic/menu';
import { memo } from 'react';
import FilterMenuFooter from './components/FilterMenuFooter';
import SearchInput from '../Search/SearchInput';
import FilterMenuHeader from './components/FilterMenuHeader';

/* #region styles */
const StyledSmartSideDrawerView = styled(SmartSideDrawerView)`
    flex-direction: column;
    background: ${ColorNeutralWhite};
`;

const StyledSecondarySectionWithDividers = styled(Menu.SecondarySectionWithDividers)`
    background: ${ColorNeutralWhite};

    & > ul > li:after {
        border-bottom: 1px solid ${ColorNordicGrey2} !important;
    }

    & > ul > li:last-child:after {
        content: none;
    }
`;

const StyledLoadingContainer = styled(LoadingContainer)`
    ${customScrollbar}
    height: 100%;
    overflow: auto;
`;

/* #endregion */

type FilterMenuProps = ISmartSideDrawerView &
    MenuHeaderProps & {
        withDividers?: boolean;
        withFooter?: boolean;
        withHeader?: boolean;
        withSearch?: boolean;
        footerRenderer?: () => JSX.Element;
    };

const FilterMenuSmartView = ({
    children,
    headline,
    backButtonCallback,
    closeButtonCallback,
    withFooter = true,
    withHeader = true,
    withSearch = false,
    withDividers,
    footerRenderer = () => <FilterMenuFooter />,
    ...restProps
}: FilterMenuProps) => {
    const isLoading = useIsFetching({ queryKey: ['filterMenuData'] });

    return (
        <StyledSmartSideDrawerView animate={false} {...restProps}>
            {withHeader && (
                <FilterMenuHeader
                    headline={headline}
                    backButtonCallback={backButtonCallback}
                    closeButtonCallback={closeButtonCallback}
                />
            )}

            <StyledLoadingContainer canUserInteract={false} isLoading={!!isLoading}>
                <Menu size="lg" shouldFocus>
                    {withSearch && <SearchInput />}
                    {withDividers ? (
                        <StyledSecondarySectionWithDividers>{children}</StyledSecondarySectionWithDividers>
                    ) : (
                        <Menu.Section>{children}</Menu.Section>
                    )}
                </Menu>
            </StyledLoadingContainer>
            {withFooter && footerRenderer()}
        </StyledSmartSideDrawerView>
    );
};

export default memo(FilterMenuSmartView);
